/*
 * @Date: 2023-04-21 17:06:47
 * @LastEditors: simLarry
 * @LastEditTime: 2023-04-25 11:24:32
 * @FilePath: \P1-M1-QRP-CODE\pages\restrict.js
 */
import React from "react";
import Header from '@/restrict/Header'; // 头部 组件
import useURLs from "$UTILS/hooks/useURLs";

const Restrict = () => {
    const openLiveChat = (language ,link) => {
        var CSLive = global.open(
            'about:blank',
            '_blank',
            'toolbar=yes, location=yes, directories=no, status=no, menubar=yes, scrollbars=yes, resizable=no, copyhistory=yes, width=650, height=650'
        );
        let languages = {
            'CN' : '必威客服聊天窗口',
            'TH' : 'ห้องแชทออนไลน์กับเจ้าหน้าที่ Kapook',
        };
        CSLive.document.title = languages[language];
        CSLive.focus();
        CSLive.location.href = link;
    }
    return (
        <div className="restrict-page">
            <Header></Header>
            <div className="restrict-bg">
                <div className="textContent">
                    <h2>网络服务范围受限</h2>
                    <h2>เครือข่ายบริการถูกจำกัด</h2>
                    <div className="restrict-flex">
                        <div className="item">
                            <p className="p1">亲爱的会员,</p>
                            <p className="p2">
                                抱歉，您所在的地区不允许使用我们的服务。 <br />
                                
                                若被发现您掩蔽真实地区位置使用我站服务，您的帐户将立即被关闭。<br />
                                
                                如果您有任何问题，请联系必威客服寻求协助。
                            </p>
                            <a className="btn" onClick={()=>{openLiveChat('CN','https://kiwiberryapp.hihi2u.com/app?')}}>在线客服</a>
                            <a className="btn" href="mailto:cs@betway88.com">cs@betway88.com</a>
                        </div>
                        <div className="item">
                            <p className="p1">Dear member,</p>
                            <p className="p2">
                                We do not accept players from your location. You are located in a restricted jurisdiction that does not
                                permit the use of our services. <br />
                                    
                                    
                                If you are found to be using this site with a location-making service, you account will be closed
                                immediately.<br />
                                    

                                you have any inquiry, please contact our customer service.
                            </p>
                            <a className="btn" onClick={()=>{openLiveChat('CN','https://kiwiberryapp.hihi2u.com/app?')}}>Contact CS</a>
                            <a className="btn" href="mailto:cs@betway88.com">cs@betway88.com</a>
                        </div>
                        <div className="item">
                            <p className="p1">เรียน ท่านสมาชิก，</p>
                            <p className="p2">
                    
                                เราไม่รับผู้เล่นจากตำแหน่งของคุณ คุณอยู่ในพื้นที่ จำกัด ที่ไม่อนุญาตให้ใช้บริการของเรา <br />
                                    
                                หากพบว่าคุณใช้ไซต์นี้กับบริการในสถานที่นั้นๆ บัญชีของคุณจะถูกปิดทันที<br />
                                    
                                หากคุณมีคำถามใด ๆ โปรดติดต่อฝ่ายบริการลูกค้าของเรา
                            </p>
                            <a className="btn" onClick={()=>{openLiveChat('TH','https://raspberryapp.hihi2u.com/app?')}}>ฝ่ายลูกค้า</a>
                            <a className="btn" href="mailto:cs.thai@betway88.com">cs.thai@betway88.com</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Restrict;